// ---- free-shipping progress, in one place -------------------------------
// The bar renders in both the cart drawer and the cart page, so on /cart there
// are two of them in the document. They were addressed by id, and
// getElementById only ever returns the first — whichever that was, the other
// kept whatever total the server rendered. Both are updated now, and the
// threshold is read off the bar so it cannot drift from the Liquid.
(function () {
  var everDone = false;
  function money(c) {
    var n = typeof c === 'number' && isFinite(c) ? c : 0;
    return window.wftMoney(n);
  }
  window.wftShipBar = function (totalCents, anchor) {
    var bars = document.querySelectorAll('.shipbar');
    if (!bars.length) return;
    var crossed = false, stillShort = false;
    [].forEach.call(bars, function (bar) {
      var thr = parseInt(bar.getAttribute('data-threshold'), 10)
             || (window.WFT && window.WFT.freeShip) || 0;
      if (thr <= 0) return;
      bar.setAttribute('data-total', totalCents);
      var left = thr - totalCents;
      var fill = bar.querySelector('.shipfill');
      var msg = bar.querySelector('.shipmsg');
      if (fill) fill.style.width = Math.min(100, totalCents * 100 / thr) + '%';
      if (left <= 0 && !bar.classList.contains('done')) crossed = true;
      if (left > 0) stillShort = true;
      bar.classList.toggle('done', left <= 0);
      if (msg) {
        msg.innerHTML = left <= 0
          ? 'Free ' + window.wftEscape(window.WFT.shippingRegion || 'U.S.') + ' ground shipping <b>unlocked</b>'
          : '<b>' + money(left) + '</b> away from free ' + window.wftEscape(window.WFT.shippingRegion || 'U.S.') + ' ground shipping';
      }
    });
    if (stillShort) everDone = false;
    if (crossed && !everDone) {          // only on the crossing, and only once
      everDone = true;
      if (typeof window.wftConfetti === 'function') window.wftConfetti(anchor || bars[0]);
    }
  };
})();

(function () {
  var saved = window.wftStorage.get('wft_saved_v2', []);
  if (!Array.isArray(saved)) saved = [];
  saved = saved.filter(function (item) { return item && /^\d+$/.test(String(item.vid)) && typeof item.name === 'string'; });
  var cart = (window.WFT && window.WFT.cartCount) || 0;
  var drawer = document.getElementById('saveDrawer');
  var scrim  = document.getElementById('saveScrim');
  var toastEl = document.getElementById('toast');
  var tmr;

  function money(n) { return window.wftMoney(Math.round(n * 100)); }
  function toast(msg, action, onAction, ms) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('act', !!action);
    if (action) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tundo';
      b.textContent = action;
      b.addEventListener('click', function () {
        toastEl.classList.remove('show', 'act');
        clearTimeout(tmr);
        onAction();
      });
      toastEl.appendChild(b);
    }
    toastEl.classList.add('show');
    clearTimeout(tmr);
    tmr = setTimeout(function () {
      toastEl.classList.remove('show', 'act');
    }, ms || 1900);
  }
  window.wftToast = toast;
  var countsQueued = false, lastSavedSnapshot = null;
  function setCounts() {
    if (countsQueued) return;
    countsQueued = true;
    queueMicrotask(function () { countsQueued = false; paintCounts(); });
  }
  function paintCounts() {
    var snapshot = JSON.stringify(saved);
    if (snapshot !== lastSavedSnapshot) {
      window.wftStorage.set('wft_saved_v2', saved);
      lastSavedSnapshot = snapshot;
    }
    var savedIds = new Set(saved.map(function (item) { return String(item.vid); }));
    document.querySelectorAll('.savebtn,.pdpsave').forEach(function (button) {
      var card = button.closest('.card');
      var id = card ? card.dataset.vid : button.dataset.vid;
      var on = savedIds.has(String(id));
      if (button.getAttribute('aria-pressed') !== String(on)) button.setAttribute('aria-pressed', String(on));
      var label = button.querySelector('span'); if (label) label.textContent = on ? 'Saved' : 'Save';
    });
    [].forEach.call(document.querySelectorAll('.savecount'), function (e) { e.textContent = saved.length; });
    [].forEach.call(document.querySelectorAll('.cartcount'), function (e) { e.textContent = cart; });
    var _sn = document.getElementById('saveN');
    if (_sn) _sn.textContent = saved.length;
    var val = saved.reduce(function (a, s) { return a + s.price * (s.quantity || 1); }, 0);
    var _sv = document.getElementById('saveVal');
    if (_sv) _sv.textContent = money(val);
    var _aa = document.getElementById('saveAddAll');
    if (_aa) _aa.disabled = saved.length === 0;
  }
  function renderDrawer() {
    var box = document.getElementById('saveItems');
    if (!box) { setCounts(); return; }
    var esc = window.wftEscape;
    box.innerHTML = saved.length ? saved.map(function (item, i) {
      var url = new URL(item.url || location.pathname, location.origin);
      if (url.origin !== location.origin) url = new URL(location.pathname, location.origin);
      url.searchParams.set('variant', item.vid);
      var src = /^https?:|^\//.test(item.img || '') ? item.img : '';
      return '<div class="si"><a class="siimg" href="' + esc(url.href) + '"><img src="' + esc(src) + '" alt="" loading="lazy"></a><div><a class="silink" href="' + esc(url.href) + '">' +
        (window.WFT.hideVendors ? '' : '<span class="br">' + esc(item.brand) + '</span>') + '<span class="nm">' + esc(item.name) + '</span></a>' +
        '<p>' + (item.available === false ? 'Currently unavailable · ' : '') + esc(item.variant || '') + '<br>SKU ' + esc(item.sku || '—') + '</p><p class="pr">' + (item.quantity || 1) + ' pack(s) · ' + money(item.price * (item.quantity || 1)) + '</p></div>' +
        '<button class="rm" type="button" data-i="' + i + '" aria-label="Remove ' + esc(item.name) + '">×</button></div>';
    }).join('') : '<p class="empty2">Nothing saved yet. Tap the heart on any style to build a buying list.</p>';
    box.querySelectorAll('.rm').forEach(function (button) {
      button.addEventListener('click', function () { saved.splice(Number(button.dataset.i), 1); renderDrawer(); });
    });
    setCounts();
  }
  function refreshSaved() {
    Promise.all(saved.map(function (item) {
      var url = new URL(item.url || '/', location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
      return fetch(url.pathname + '.js').then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function (product) {
        var variant = product.variants.find(function (v) { return String(v.id) === String(item.vid); });
        if (variant) { item.price = variant.price / 100; item.sku = variant.sku; item.variant = variant.title; item.available = variant.available; }
        else item.available = false;
      }).catch(function () { /* Retain the last snapshot; Shopify validates before adding. */ });
    })).then(renderDrawer);
  }
  function openDrawer(open) {
    if (!drawer || !scrim) return;
    if (open) { renderDrawer(); refreshSaved(); }
    drawer.classList.toggle('open', open);
    scrim.classList.toggle('open', open);
  }

  // Saved entries represent exact variants and retain the requested quantity.
  function bindSave(root) {
    (root || document).querySelectorAll('.savebtn:not([data-save-bound]),.pdpsave:not([data-save-bound])').forEach(function (button) {
      button.dataset.saveBound = '1';
      button.addEventListener('click', function () {
        var card = button.closest('.card'), host = card || button;
        var run = card ? card.querySelector('.qarun.on:not([hidden])') : document.querySelector('.packcard.on');
        var id = card ? card.dataset.vid : button.dataset.vid;
        if (!id) { toast('Choose an available pack before saving'); return; }
        var index = saved.findIndex(function (item) { return String(item.vid) === String(id); });
        if (index >= 0) { saved.splice(index, 1); toast('Removed from saved'); }
        else {
          var qty = card ? card.querySelector('[name="quantity"]') : document.getElementById('qty');
          var img = card ? card.querySelector('figure img') : document.querySelector('.gal .main img');
          saved.push({ vid: String(id), productId: host.dataset.productId, name: host.dataset.name,
            brand: host.dataset.brand, unit: Number(host.dataset.unit) || 0,
            price: Number(run ? run.dataset.price : host.dataset.price) || 0,
            sku: run ? run.dataset.sku : '', variant: run ? (run.dataset.title || (run.querySelector('.pk-run') || run).textContent.trim()) : '',
            quantity: Math.max(1, Number(qty && qty.value) || 1), url: host.dataset.url, img: img ? img.src : '' });
          window.wftTrack('save_style', {variant_id:String(id)});
        }
        renderDrawer();
        if (index < 0) openDrawer(true);
      });
    });
    setCounts();
  }
  bindSave(document);
  document.addEventListener('wft:variant', function () { setCounts(); });
  document.addEventListener('wft:cart', function (e) { cart = e.detail.item_count; setCounts(); });
  window.addEventListener('storage', function (event) {
    if (event.key !== 'wft_saved_v2') return;
    var fresh = window.wftStorage.get('wft_saved_v2', []);
    if (Array.isArray(fresh)) { saved = fresh.filter(function (item) { return item && /^\d+$/.test(String(item.vid)); }); renderDrawer(); }
  });

  // One selection path updates everything a buyer sees or submits on a card.
  var quickPanelSequence = 0;
  var closeQuickSheet = null;
  document.addEventListener('wft:close-quick-add', function () { if (closeQuickSheet) closeQuickSheet(); });
  window.matchMedia('(min-width:901px)').addEventListener('change', function (event) { if (event.matches && closeQuickSheet) closeQuickSheet(); });
  document.addEventListener('shopify:section:unload', function () { if (closeQuickSheet) closeQuickSheet(); });
  function bindQuickAdd(root) {
    (root || document).querySelectorAll('.card:not([data-qa-bound])').forEach(function (card) {
      var panel = card.querySelector('.qapanel'); if (!panel) return;
      card.dataset.qaBound = '1';
      var runs = Array.from(panel.querySelectorAll('.qarun'));
      var qty = panel.querySelector('[name="quantity"]'), add = panel.querySelector('.qaadd'), id = panel.querySelector('.qavid');
      if (!qty || !add || !id) return;
      function sync(run) {
        // A cloned quick view may inherit visibility from another selected color.
        // Reconcile every pack against the actual selection on every update.
        if (run) runs.forEach(function (r) { r.hidden = !!r.dataset.c && r.dataset.c !== run.dataset.c; });
        var runList = panel.querySelector('.qaruns');
        if (runList && run && card.dataset.packColor !== run.dataset.c) runList.scrollTop = 0;
        card.dataset.packColor = run ? run.dataset.c : '';
        runs.forEach(function (r) { r.classList.toggle('on', r === run); r.setAttribute('aria-pressed', String(r === run)); });
        id.value = run ? run.dataset.vid : '';
        card.dataset.vid = id.value;
        add.disabled = !run;
        var saveButton = card.querySelector('.savebtn'); if (saveButton) saveButton.disabled = !run;
        if (!run) {
          add.textContent = 'Sold out'; card.dataset.stock = '0'; card.dataset.price = ''; card.dataset.unit = '';
          var emptySku = card.querySelector('.cardsku'); if (emptySku) emptySku.textContent = '';
          card.querySelectorAll('.unit b,.mini b').forEach(function (el) { el.textContent = 'Unavailable'; });
          card.querySelectorAll('.flag,.badge--final').forEach(function (el) { el.hidden = true; });
          card.querySelector('.priceblock').classList.remove('onsale');
          setCounts(); return;
        }
        var stock = Number(run.dataset.stock), price = Number(run.dataset.price), pcs = Number(run.dataset.pcs) || 1;
        var max = run.dataset.tracked === '1' && run.dataset.policy === 'deny' ? Math.max(0, stock) : Infinity;
        if (max !== Infinity) qty.max = max; else qty.removeAttribute('max');
        qty.value = Math.max(1, Math.min(max, Math.floor(Number(qty.value) || 1)));
        add.disabled = max === 0;
        card.dataset.price = price; card.dataset.unit = price / pcs; card.dataset.pack = pcs; card.dataset.stock = stock;
        if(run.dataset.perUnit !== undefined)card.dataset.perUnit = run.dataset.perUnit;
        card.querySelectorAll('.unit i').forEach(function(label){label.textContent=card.dataset.perUnit==='true'?'/ unit':'/ pack';});
        card.querySelectorAll('.mini').forEach(function(mini){mini.hidden=card.dataset.perUnit!=='true';});
        var url = new URL(card.dataset.url, location.origin); url.searchParams.set('variant', run.dataset.vid);
        card.querySelectorAll('a.cardlink').forEach(function (a) { a.href = url.href; });
        var sku = card.querySelector('.cardsku'); if (sku) sku.textContent = run.dataset.sku || '';
        card.querySelectorAll('.unit b,.mini b').forEach(function (b) { b.textContent = money(card.dataset.perUnit === 'true' ? price / pcs : price); });
        var compare = Number(run.dataset.compare), sale = compare > price;
        card.querySelector('.priceblock').classList.toggle('onsale', sale);
        var line = card.querySelector('.packline');
        line.innerHTML = card.classList.contains('quickview-card')
          ? (sale ? '<s>' + money(compare) + '</s>' : '') + '<b>' + money(price) + '</b><span>per ' + pcs + '-piece pack</span>'
          : (sale ? '<s>' + money(compare) + '</s> <em>' + money(price) + '</em>' : money(price)) + ' per ' + pcs + '-pack';
        card.querySelectorAll('figure,.cardtags').forEach(function (area) {
          var badge = area.querySelector('.flag');
          if (!badge) { badge = document.createElement('span'); badge.className = 'flag'; area.appendChild(badge); }
          badge.hidden = !sale; badge.textContent = sale ? Math.floor((compare - price) * 100 / compare + .000001) + '% off' : '';
          var stack = area.querySelector('.pkstack');
          if (!stack) { stack = document.createElement('span'); stack.className = 'pkstack'; area.appendChild(stack); }
          var low = stack.querySelector('.badge--final');
          if (!low) { low = document.createElement('span'); low.className = 'badge badge--final'; stack.appendChild(low); }
          low.hidden = !(run.dataset.tracked === '1' && stock > 0 && stock <= window.WFT.lowStock);
          low.textContent = stock + ' pack' + (stock === 1 ? '' : 's') + ' left';
        });
        var img = card.querySelector('figure img:not(.alt)');
        if (img && run.dataset.img && img.src !== new URL(run.dataset.img, location.href).href) {
          window.wftSetResponsiveImage(img, run.dataset.img);
        }
        var alt = card.querySelector('figure img.alt');
        if (!card.classList.contains('quickview-card')) {
          if (!alt && img && run.dataset.nextImg) {
            alt = img.cloneNode(false); alt.removeAttribute('id'); alt.className = 'alt';
            alt.alt = ''; alt.setAttribute('aria-hidden', 'true'); alt.loading = 'lazy';
            alt.setAttribute('fetchpriority', 'auto'); img.after(alt);
          }
          if (alt) {
            alt.hidden = !run.dataset.nextImg;
            if (run.dataset.nextImg) window.wftSetResponsiveImage(alt, run.dataset.nextImg);
          }
        } else if (alt) alt.hidden = true;
        card.querySelectorAll('.swrow .sw').forEach(function (sw) { sw.setAttribute('aria-pressed', String(sw.dataset.c === run.dataset.c)); });
        add.textContent = 'Add · ' + money(price * Number(qty.value));
        if(card.classList.contains('quickview-card')){
          add.textContent='';
          var addLabel=document.createElement('span');addLabel.textContent='Add '+qty.value+' pack'+(Number(qty.value)===1?'':'s')+' to order';
          var addTotal=document.createElement('span');addTotal.textContent=money(price*Number(qty.value));add.append(addLabel,addTotal);
        }
        setCounts();
        if (card.dataset.selectionReady) card.dispatchEvent(new CustomEvent('wft:card-selection', {bubbles:true}));
        card.dataset.selectionReady = '1';
      }
      card.wftSelect = sync;
      runs.forEach(function (run) { run.addEventListener('click', function () { sync(run); window.wftTrack('variant_selected', {variant_id:run.dataset.vid}); }); });
      panel.querySelectorAll('.qastep button').forEach(function (button) { button.addEventListener('click', function () { qty.value = Number(qty.value) + Number(button.dataset.d); sync(panel.querySelector('.qarun.on:not([hidden])')); }); });
      qty.addEventListener('change', function () { sync(panel.querySelector('.qarun.on:not([hidden])')); });
      var open = card.querySelector('.qabtn'), close = panel.querySelector('.qaclose');
      panel.id = 'QuickAdd-' + (++quickPanelSequence); panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Quick add ' + (card.dataset.name || 'style'));
      if (open) { open.setAttribute('aria-controls', panel.id); open.setAttribute('aria-expanded', String(!panel.hidden)); }
      new MutationObserver(function () { if (open) open.setAttribute('aria-expanded', String(!panel.hidden)); }).observe(panel, {attributes:true,attributeFilter:['hidden']});
      function dismiss() {
        if (closeQuickSheet) closeQuickSheet();
        else { panel.hidden = true; if (open) open.focus({preventScroll:true}); }
      }
      if (open) open.addEventListener('click', function () {
        if (closeQuickSheet) closeQuickSheet();
        document.querySelectorAll('.qapanel').forEach(function (p) { p.hidden = true; });
        panel.hidden = false;
        if (window.matchMedia('(max-width:900px)').matches) {
          var sheet = document.createElement('dialog');
          sheet.className = 'quick-add-sheet';
          sheet.setAttribute('aria-label', panel.getAttribute('aria-label'));
          var marker = document.createComment('Quick add position');
          panel.before(marker);
          card.appendChild(sheet);
          sheet.appendChild(panel);
          var previousOverflow = document.documentElement.style.overflow;
          closeQuickSheet = function () {
            closeQuickSheet = null;
            sheet.close();
            panel.hidden = true;
            marker.replaceWith(panel);
            sheet.remove();
            document.documentElement.style.overflow = previousOverflow;
            if (open.isConnected) open.focus({preventScroll:true});
          };
          sheet.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
          sheet.addEventListener('click', function (event) {
            if (event.target !== sheet) return;
            var rect = sheet.getBoundingClientRect();
            if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) dismiss();
          });
          sheet.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        if (close) close.focus();
      });
      if (close) close.addEventListener('click', dismiss);
      panel.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); dismiss(); } });
      sync(runs.find(function (run) { return run.dataset.vid === id.value; }) || runs[0]);
    });
  }
  function bindSwatches(root) {
    (root || document).querySelectorAll('.card:not([data-sw-bound])').forEach(function (card) {
      card.dataset.swBound = '1';
      card.querySelectorAll('.swrow .sw').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var runs = Array.from(card.querySelectorAll('.qarun'));
          runs.forEach(function (run) { run.hidden = !!run.dataset.c && run.dataset.c !== sw.dataset.c; });
          var run = runs.find(function (r) { return !r.hidden && r.classList.contains('on'); }) || runs.find(function (r) { return !r.hidden; });
          if (card.wftSelect) card.wftSelect(run);
          card.querySelectorAll('.swrow .sw').forEach(function (item) { item.setAttribute('aria-pressed', String(item === sw)); });
          if (!run) {
            var img = card.querySelector('figure img:not(.alt)');
            if (img && sw.dataset.img) { window.wftSetResponsiveImage(img, sw.dataset.img); }
            card.querySelectorAll('a.cardlink').forEach(function (link) { link.href = sw.dataset.url; });
            var line = card.querySelector('.packline'); if (line) line.textContent = 'No packs available in this color';
          }
        });
      });
    });
  }
  bindQuickAdd(document); bindSwatches(document);
  window.wftBindCards = function (root) { bindSave(root); bindQuickAdd(root); bindSwatches(root); document.dispatchEvent(new CustomEvent('wft:cards', {detail:{root:root}})); };

  // ---- PDP gallery ---------------------------------------------------
  // The swap used to wait a fixed 90ms and only then start fetching a 1400px
  // image, so every first view of an image paid the fade plus the download.
  // The full sizes are warmed in the background and the swap waits on decode,
  // which makes a cached image change on the same frame as the click.
  (function () {
    var main = document.querySelector('.gal .main img');
    var thumbs = [].slice.call(document.querySelectorAll('.gal .thumbs img'));
    if (!main) return;

    var frame = main.parentElement;
    var zoom = document.createElement('span');
    zoom.className = 'gallery-zoom';
    zoom.setAttribute('aria-hidden', 'true');
    frame.appendChild(zoom);
    frame.classList.add('gallery-zoomable');
    frame.setAttribute('role', 'button');
    frame.setAttribute('tabindex', '0');
    var zoomed = false, zoomX = 50, zoomY = 50;
    function positionZoom(x, y) {
      zoomX = Math.max(0, Math.min(100, x));
      zoomY = Math.max(0, Math.min(100, y));
      zoom.style.backgroundPosition = zoomX + '% ' + zoomY + '%';
    }
    function setZoom(on) {
      zoomed = on;
      if (on) {
        var source = main.getAttribute('data-zoom') || main.currentSrc || main.src;
        zoom.style.backgroundImage = 'url(' + JSON.stringify(source) + ')';
        var original = thumbs.find(function (t) { return t.getAttribute('data-full') === main.getAttribute('src'); });
        var nativeWidth = Number(original && original.getAttribute('data-w')) || main.naturalWidth;
        var scale = nativeWidth && frame.clientWidth ? Math.max(1, Math.min(2, nativeWidth / frame.clientWidth)) : 2;
        zoom.style.backgroundSize = (scale * 100) + '% ' + (scale * 100) + '%';
      }
      frame.classList.toggle('is-zoomed', on);
      frame.setAttribute('aria-pressed', on ? 'true' : 'false');
      frame.setAttribute('aria-label', on
        ? 'Zoom out of product image. Move the mouse or use arrow keys to explore.'
        : 'Zoom in on product image');
    }
    function followPointer(e) {
      var rect = frame.getBoundingClientRect();
      if (rect.width && rect.height) positionZoom(
        (e.clientX - rect.left) / rect.width * 100,
        (e.clientY - rect.top) / rect.height * 100
      );
    }
    frame.addEventListener('click', function (e) {
      if (!zoomed) {
        if (e.detail) followPointer(e);
        else positionZoom(50, 50);
      }
      setZoom(!zoomed);
    });
    frame.addEventListener('pointermove', function (e) {
      if (zoomed && e.pointerType !== 'touch') followPointer(e);
    });
    frame.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!zoomed) positionZoom(50, 50);
        setZoom(!zoomed);
      } else if (e.key === 'Escape') {
        e.preventDefault(); setZoom(false);
      } else if (zoomed && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) !== -1) {
        e.preventDefault();
        positionZoom(zoomX + (e.key === 'ArrowRight' ? 10 : e.key === 'ArrowLeft' ? -10 : 0),
          zoomY + (e.key === 'ArrowDown' ? 10 : e.key === 'ArrowUp' ? -10 : 0));
      }
    });
    // Thumbnail and color changes must both leave the new photo unzoomed.
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.attributeName === 'src' && main.src !== change.oldValue) {
          setZoom(false);
          // Color swatches supply a full image URL without a separate zoom URL.
          var selectedThumb = thumbs.find(function (t) { return t.getAttribute('data-full') === main.getAttribute('src'); });
          if (selectedThumb) main.setAttribute('data-zoom', selectedThumb.getAttribute('data-zoom') || main.src);
          else { var zoomUrl = new URL(main.src); zoomUrl.searchParams.set('width', '2400'); main.setAttribute('data-zoom', zoomUrl.href); }
        }
      });
    }).observe(main, { attributes: true, attributeFilter: ['src'], attributeOldValue: true });
    setZoom(false);

    var imageRequest = 0;
    main.addEventListener('variant:image', function () { imageRequest++; setZoom(false); });
    var cache = {};
    function warm(url) {
      if (!url) return null;
      if (!cache[url]) { var im = new Image(); im.src = url; cache[url] = im; }
      return cache[url];
    }
    function fullOf(t) { return t.getAttribute('data-full') || t.currentSrc || t.src; }

    // Load alternate full-size photographs on hover, focus, or selection.
    thumbs.forEach(function (t, i) {
      t.setAttribute('tabindex', '0');
      t.setAttribute('role', 'button');
      t.setAttribute('aria-label', 'View image ' + (i + 1));

      // hovering a thumb is a strong hint it is about to be clicked
      t.addEventListener('mouseenter', function () { warm(fullOf(t)); });
      t.addEventListener('focus', function () { warm(fullOf(t)); });

      function show() {
        var request = ++imageRequest;
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var url = fullOf(t);
        var im = warm(url);
        function swap() {
          if (request !== imageRequest) return;
          main.removeAttribute('srcset');       // the thumb's full-size URL wins
          main.src = url;
          main.setAttribute('data-zoom', t.getAttribute('data-zoom') || url);
          main.alt = t.alt;
          // the images are no longer cropped to one shape, so the reserved box
          // has to follow the photograph or the page jumps as it lands
          var w = (im && im.naturalWidth) || +t.getAttribute('data-w');
          var h = (im && im.naturalHeight) || +t.getAttribute('data-h');
          if (w && h) { main.setAttribute('width', w); main.setAttribute('height', h); }
          main.style.opacity = '1';
        }
        if (im && im.complete && im.naturalWidth) { swap(); return; }   // already there
        main.style.opacity = '.62';             // dim, never blank, while it arrives
        if (im && im.decode) im.decode().then(swap).catch(swap);
        else if (im) { im.onload = swap; im.onerror = swap; }
        else swap();
      }
      t.addEventListener('click', show);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(); } });
    });
  })();

  // ---- collection sort ----------------------------------------------
  (function () {
    var sel = document.getElementById('sortSel');
    if (!sel) return;
    var grid = sel.closest('.in').querySelector('.goods');
    if (!grid) return;
    var num = function (el, attr) { return parseFloat(el.getAttribute(attr)) || 0; };
    function apply(v) {
      // promo tiles hold their slot; only the products reorder around them
      var cards = [].slice.call(grid.querySelectorAll('.card:not(.promocard)'));
      cards.sort(function (a, b) {
        switch (v) {
          case 'unit-asc':   return num(a,'data-unit')  - num(b,'data-unit');
          case 'unit-desc':  return num(b,'data-unit')  - num(a,'data-unit');
          case 'pack-asc':   return num(a,'data-pack')  - num(b,'data-pack');
          case 'pack-desc':  return num(b,'data-pack')  - num(a,'data-pack');
          case 'stock-desc': return num(b,'data-stock') - num(a,'data-stock');
          case 'stock-asc':  return num(a,'data-stock') - num(b,'data-stock');
          default:           return num(a,'data-seq')   - num(b,'data-seq');
        }
      });
      // Rebuild the whole child order in one pass. Replacing nodes one at a
      // time moves elements that later iterations still point at, which drops
      // cards from the grid.
      var children = [].slice.call(grid.children);
      var k = 0;
      var out = children.map(function (n) {
        var isProduct = n.classList.contains('card') && !n.classList.contains('promocard');
        return isProduct ? cards[k++] : n;    // promo tiles keep their slot
      });
      out.forEach(function (n) { grid.appendChild(n); });
    }

    var resetSort = document.getElementById('resetSort');
    if (resetSort) {
      resetSort.hidden = false;
      resetSort.addEventListener('click', function () {
        // Reload the collection's own order, including after a client-side sort.
        // The sort form already carries active filters and omits pagination.
        sel.value = sel.getAttribute('data-default-sort');
        var form = document.getElementById('sortForm');
        if (form) form.submit();
      });
    }

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (!opt.getAttribute('data-client')) {   // native Shopify order — reload
        var form = document.getElementById('sortForm');
        if (form) { form.submit(); return; }
      }
      apply(sel.value);
      toast('Sorted by ' + opt.text.toLowerCase());
    });

    // Show more appends the next page at the end; if a wholesale order is
    // active those cards have to be folded into it rather than tacked on.
    window.wftResort = function () {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.getAttribute('data-client')) apply(sel.value);
    };
  })();


  // ---- collection view controls --------------------------------------
  (function () {
    var perRow = document.getElementById('perRow');
    if (!perRow) return;
    var scope = perRow.closest('.in') || document;
    var grid  = scope.querySelector('.goods');
    var layout = scope.querySelector('.layout');
    if (!grid) return;

    var KEY = 'wft_view';
    var state = { n: 5, notext: false, norail: false, bulk: false, img: 148, gimg: 400 };
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    try { state = Object.assign(state, JSON.parse(saved || '{}')); } catch (e) {}

    // Upgrade the former default while retaining deliberately adjusted sizes.
    if (state.img === 52) state.img = 148;

    var tText    = document.getElementById('tText'),
        tRail    = document.getElementById('tRail'),
        tBulk    = document.getElementById('tBulk'),
        bulkHead = document.getElementById('bulkHead'),
        bulkZoom = document.getElementById('bulkZoom'),
        zoomIn   = document.getElementById('bulkZoomIn');

    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    function narrow() { return window.matchMedia('(max-width:900px)').matches; }

    // The slider means different things in the two views: how tall the card's
    // photograph is cropped, or how wide the row's thumbnail is. It keeps a
    // value for each so switching view does not throw the other away.
    var ZOOM = {
      grid: { min: 260, max: 560, step: 20, key: 'gimg', def: 400 },
      bulk: { min: 40,  max: 160, step: 4,  key: 'img',  def: 148 }
    };
    function zoomMode() { return state.bulk ? ZOOM.bulk : ZOOM.grid; }
    function applyZoom() {
      var g = (state.gimg || ZOOM.grid.def) / 100;
      var b = (state.img || ZOOM.bulk.def);
      grid.style.setProperty('--imgratio', g);
      grid.style.setProperty('--bulkimg', b + 'px');
      if (bulkHead) bulkHead.style.setProperty('--bulkimg', b + 'px');
    }
    function paintZoom() {
      var m = zoomMode();
      if (zoomIn) {
        zoomIn.min = m.min; zoomIn.max = m.max; zoomIn.step = m.step;
        zoomIn.value = state[m.key] || m.def;
      }
      applyZoom();
    }

    function paint() {
      // narrow viewports keep their own responsive column count
      if (window.matchMedia('(min-width: 1181px)').matches) {
        grid.style.setProperty('--cols', state.n);
      } else {
        grid.style.removeProperty('--cols');
      }
      // the bulk list is a different reading of the same cards, so the
      // card-only densities step aside while it is on
      grid.classList.toggle('bulk', !!state.bulk);
      // compact is no longer a control; it is what a narrow screen gets
      grid.classList.toggle('compact', !state.bulk && narrow());
      grid.classList.toggle('notext', !state.bulk && !!state.notext);
      if (bulkHead) bulkHead.classList.toggle('on', !!state.bulk);
      paintZoom();
      if (tText) tText.disabled = !!state.bulk;
      // the SKU and the quick-add form carry the hidden attribute, and the
      // theme's [hidden] rule is !important — CSS cannot reveal them, so the
      // attribute itself is what has to move
      [].forEach.call(grid.querySelectorAll('.card'), function (card) {
        var sku = card.querySelector('.cardsku');
        var tags = card.querySelector('.cardtags');
        var qa = card.querySelector('.qapanel');
        if (sku) sku.hidden = !state.bulk;
        if (tags) tags.hidden = !state.bulk;
        if (qa) qa.hidden = !state.bulk;
      });
      if (layout) layout.classList.toggle('norail', !!state.norail);

      [].forEach.call(perRow.querySelectorAll('button'), function (b) {
        b.classList.toggle('on', +b.getAttribute('data-n') === state.n);
      });
      if (tText)    tText.setAttribute('aria-pressed', String(!!state.notext));
      if (tRail)    tRail.setAttribute('aria-pressed', String(!!state.norail));
      if (tBulk)    tBulk.setAttribute('aria-pressed', String(!!state.bulk));
    }

    [].forEach.call(perRow.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        state.n = +b.getAttribute('data-n'); save(); paint();
        if (typeof toast === 'function') toast(state.n + ' per row');
      });
    });
    function bind(el, key, onMsg, offMsg) {
      if (!el) return;
      el.addEventListener('click', function () {
        state[key] = !state[key]; save(); paint();
        if (typeof toast === 'function') toast(state[key] ? onMsg : offMsg);
      });
    }
    bind(tText,    'notext',  'Images only',    'Details shown');
    bind(tRail,    'norail',  'Filters hidden', 'Filters shown');
    bind(tBulk,    'bulk',    'Bulk order list', 'Grid view');

    if (zoomIn) {
      zoomIn.addEventListener('input', function () {
        var m = zoomMode();
        state[m.key] = +zoomIn.value || m.def;
        applyZoom();
      });
      zoomIn.addEventListener('change', save);   // one write per drag, not per pixel
    }

    window.addEventListener('resize', paint);
    window.wftPaintView = paint;      // cards added by Show more need this too
    paint();
  })();



  // ---- help centre search --------------------------------------------
  (function () {
    var box = document.getElementById('kbSearch');
    if (!box) return;
    var body = document.getElementById('kbBody');
    var empty = document.getElementById('kbEmpty');
    var qs = [].slice.call(body.querySelectorAll('.kbq'));
    var secs = [].slice.call(body.querySelectorAll('.kbsec'));
    function run() {
      var t = box.value.trim().toLowerCase();
      var hits = 0;
      qs.forEach(function (d) {
        var match = !t || d.textContent.toLowerCase().indexOf(t) > -1;
        d.hidden = !match;
        if (match) { hits++; if (t) d.open = true; }
      });
      secs.forEach(function (s) {
        s.hidden = [].slice.call(s.querySelectorAll('.kbq')).every(function (d) { return d.hidden; });
      });
      if (empty) empty.hidden = hits > 0;
    }
    box.addEventListener('input', run);
    box.addEventListener('search', run);
  })();


  // ---- mobile: filters + sort + view live in one drawer -------------
  (function () {
    var rail = document.getElementById('rail');
    if (!rail) return;
    var scrim = document.getElementById('railScrim');
    var mq = window.matchMedia('(max-width: 900px)');
    var sortwrap = document.querySelector('.sortwrap');
    var viewctl  = document.querySelector('.viewctl');
    var homeSort = sortwrap && sortwrap.parentNode;
    var homeView = viewctl && viewctl.parentNode;
    var head = rail.querySelector('.railhead');

    var options = document.createElement('details');
    options.className = 'mobile-view-options';
    options.innerHTML = '<summary>Sort &amp; display</summary>';
    head.insertAdjacentElement('afterend', options);

    function relocate() {
      if (mq.matches) {                       // phone: controls belong in the drawer
        options.hidden = false;
        if (sortwrap) options.appendChild(sortwrap);
        if (viewctl) options.appendChild(viewctl);
      } else {                                 // desktop: back to the toolbar
        options.hidden = true;
        if (sortwrap && homeSort && sortwrap.parentNode !== homeSort) homeSort.appendChild(sortwrap);
        if (viewctl && homeView && viewctl.parentNode !== homeView) homeView.appendChild(viewctl);
        open(false);
      }
    }
    function open(on) {
      rail.classList.toggle('open', on);
      if (scrim) scrim.classList.toggle('open', on);
    }
    var f = document.getElementById('mobFilter'), v = document.getElementById('mobView');
    if (f) f.addEventListener('click', function () { open(true); });
    if (v) v.addEventListener('click', function () { open(true); });
    var c = document.getElementById('railClose'); if (c) c.addEventListener('click', function () { open(false); });
    var ap = document.getElementById('railApply'); if (ap) ap.addEventListener('click', function (e) { e.preventDefault(); open(false); });
    if (scrim) scrim.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    (mq.addEventListener ? mq.addEventListener('change', relocate) : mq.addListener(relocate));
    relocate();
  })();

  // ---- drawer -------------------------------------------------------
  [].forEach.call(document.querySelectorAll('.savedlink'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(true); });
  });
  // Guarded: these live in a layout snippet a merchant could remove, and an
  // uncaught null here would kill every behaviour defined after it.
  var _sc = document.getElementById('saveClose');
  if (_sc) _sc.addEventListener('click', function () { openDrawer(false); });
  if (scrim) scrim.addEventListener('click', function () { openDrawer(false); });
  var _sa = document.getElementById('saveAddAll');
  if (_sa) _sa.addEventListener('click', function () {
    // one AJAX add per saved style, then refresh the cart count
    var items = saved.filter(function (s) { return s.vid && s.available !== false; }).map(function (s) { return { id: s.vid, quantity: s.quantity || 1 }; });
    if (!items.length) { toast('Saved styles need a pack selected'); return; }
    fetch(wftRoute('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-sale-badges', sections_url: wftRoute('cart') })
    }).then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'Unable to add saved packs'); return data; }); }).then(function (response) {
      openDrawer(false);
      if (window.WFT && window.WFT.cartDrawer === false) window.location.href = wftRoute('cart');
      else if (window.wftShowAddedCart) return window.wftShowAddedCart(response);
      else document.dispatchEvent(new Event('wft:open-cart'));
    }).catch(function (error) { toast(error.message || 'Could not add — try again'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });


  // ---- email pop-up --------------------------------------------------
  (function () {
    var pop = document.getElementById('epop'), scrim = document.getElementById('epScrim');
    if (!pop) return;
    var KEY = 'wft_epop_last_shown', SUBSCRIBED = 'wft_newsletter_subscribed';
    var started = Date.now(), shown = false, retry = null;
    var cooldown = (Number(pop.dataset.cooldown) || 7) * 86400000;
    function read(key) { try { return localStorage.getItem(key); } catch (e) { try { return sessionStorage.getItem(key); } catch (e) { return null; } } }
    function write(key, value) { try { localStorage.setItem(key, value); } catch (e) { try { sessionStorage.setItem(key, value); } catch (e) {} } }
    // Replace the previous permanent dismissal with a fresh, finite cooldown.
    if (read('wft_epop_seen') && !read(KEY)) write(KEY, String(Date.now()));
    function eligible() { return !shown && pop.dataset.subscribed !== 'true' && !read(SUBSCRIBED) && Date.now() - Number(read(KEY) || 0) >= cooldown; }
    function visible(el) { return el && !el.hidden && !el.inert && el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length; }
    function blocked() {
      return document.hidden || (document.activeElement && document.activeElement.matches('input,textarea,select,[contenteditable="true"]')) ||
        Array.from(document.querySelectorAll('[role="dialog"],[aria-modal="true"],#shopify-pc__banner,.cartdrawer.open,.savedrawer.open,.rail.open,.mobile-menu:not([hidden]),.mega:not([hidden]),.qapanel:not([hidden])')).some(function (el) { return el !== pop && visible(el); });
    }
    function close() { pop.hidden = true; if (scrim) scrim.hidden = true; }
    function stop() { if (retry) clearInterval(retry); document.removeEventListener('mouseout', onExit); window.removeEventListener('scroll', onScroll); }
    function show(force) {
      if (!force && (!eligible() || blocked())) return false;
      shown = true; stop(); write(KEY, String(Date.now()));
      pop.hidden = false; if (scrim) scrim.hidden = false;
      return true;
    }
    var seg = document.getElementById('epSeg'), tags = document.getElementById('epTags');
    if (seg) {
      seg.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          seg.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on'); if (tags) tags.value = 'newsletter,' + b.getAttribute('data-seg');
        });
      });
      var first = seg.querySelector('button.on'); if (first && tags) tags.value = 'newsletter,' + first.getAttribute('data-seg');
    }
    var x = document.getElementById('epClose'); if (x) x.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var success = pop.querySelector('[data-newsletter-success]'), errors = pop.querySelector('[data-newsletter-errors]');
    // Shopify renders customer-form results in multiple forms; only reopen the submitted popup.
    var popupResponse = window.location.hash === '#NewsletterSignup';
    var footerSuccess = document.querySelector('#FooterNewsletter .footer-signup-result');
    if (footerSuccess || (success && popupResponse)) write(SUBSCRIBED, '1');
    if ((success || errors) && popupResponse) {
      show(true); if (success && window.wftTrack) window.wftTrack('newsletter_signup');
      return;
    }
    if (!eligible() || (window.Shopify && window.Shopify.designMode)) return;
    function mobile() { return matchMedia('(max-width:900px), (hover:none)').matches; }
    function mode() { return mobile() ? (pop.dataset.mobileTrigger || 'scroll') : (pop.dataset.trigger || 'timer'); }
    function ready() { return Date.now() - started >= (mobile() ? Number(pop.dataset.mobileDelay || 30) : Number(pop.dataset.delay || 0)) * 1000; }
    function onExit(event) { if (!mobile() && mode() === 'exit' && ready() && !event.relatedTarget && event.clientY <= 0) show(false); }
    function onScroll() {
      if (mode() !== 'scroll' || !ready()) return;
      var distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0 && window.scrollY / distance >= (Number(pop.dataset.scroll) || 50) / 100) show(false);
    }
    document.addEventListener('mouseout', onExit);
    window.addEventListener('scroll', onScroll, {passive:true});
    function check() {
      if (!eligible()) { stop(); return; }
      if (!ready()) return;
      if (mode() === 'timer') show(false);
      else if (mode() === 'scroll') onScroll();
    }
    check(); if (!shown) retry = setInterval(check, 1000);
  })();

  setCounts();
})();


(function () {
  var root = document.getElementById('packList');
  if (!root) return;
  var pdpRoot = document.querySelector('[data-pdp]');
  var UNIT = pdpRoot ? (parseFloat(pdpRoot.getAttribute('data-unit')) || 0) : 0;
  var LOW = pdpRoot ? (parseInt(pdpRoot.getAttribute('data-lowstock'), 10) || 4) : 4;
  var avail = [].slice.call(document.querySelectorAll('#packList .packcard'));
  var oos   = [].slice.call(document.querySelectorAll('#oosBox .packcard'));
  var swatches = [].slice.call(document.querySelectorAll('#colourRow label'));
  var qty = document.getElementById('qty');
  var el = function (id) { return document.getElementById(id); };
  // Every one of these ids is optional — a product without a margin calculator
  // or a notify row is normal. An unguarded write here throws, and because the
  // file is a sequence of IIFEs that kills everything after it, which is how a
  // missing element on one page silently disabled the cart drawer.
  var setText = function (id, v) { var e = el(id); if (e) e.textContent = v; };
  var setHidden = function (id, v) { var e = el(id); if (e) e.hidden = v; };
  var state = { price: 0, pcs: 1, stock: 0, colour: null, max: Infinity };
  var initialImage = document.querySelector('.gal .main img');
  var defaultImage = initialImage && initialImage.getAttribute('src');

  // How many packs this variant will actually sell. Only a tracked variant that
  // refuses oversell has a ceiling: an untracked one renders data-stock="0"
  // (the Liquid defaults it), and "continue selling" is a deliberate backorder.
  function maxPacks(card) {
    if (!card) return Infinity;
    if (card.getAttribute('data-tracked') !== '1') return Infinity;
    if ((card.getAttribute('data-policy') || '') !== 'deny') return Infinity;
    var n = parseInt(card.getAttribute('data-stock'), 10);
    return isFinite(n) && n > 0 ? n : Infinity;
  }

  function money(n) { return window.wftMoney(Math.round(n * 100)); }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

  function selectPack(card) {
    avail.concat(oos).forEach(function (c) { c.classList.remove('on'); c.setAttribute('aria-pressed', 'false'); });
    card.classList.add('on'); card.setAttribute('aria-pressed', 'true');
    state.price = parseFloat(card.getAttribute('data-price')) || 0;
    state.pcs = parseInt(card.getAttribute('data-pcs'), 10) || 1;
    state.stock = parseInt(card.getAttribute('data-stock'), 10) || 0;
    state.max = maxPacks(card);
    // switching from a pack with twenty in stock to one with three has to bring
    // the number down with it, or the order is impossible before it is placed
    if (state.max !== Infinity && (parseInt(qty.value, 10) || 1) > state.max) {
      qty.value = state.max;
    }
    var vid = document.getElementById('variantId');
    if (vid && card.getAttribute('data-vid')) vid.value = card.getAttribute('data-vid');
    var skuEl = el('sku'), sku = card.getAttribute('data-sku');
    if (skuEl) skuEl.textContent = sku || '';
    setHidden('skuRow', !sku);
    if (el('bisSku')) el('bisSku').value = sku || '';
    UNIT = Math.round(state.price / state.pcs * 100) / 100;
    var compare = parseFloat(card.getAttribute('data-compare')) || 0;
    var sale = compare > state.price;
    setHidden('saleBadge', !sale);
    setHidden('saleCaption', !sale);
    setHidden('unitWas', !sale);
    setHidden('packWas', !sale);
    setHidden('productBadges', !sale && !document.querySelector('#productBadges .badge--plus'));
    if (sale) {
      setText('saleBadge', Math.floor((Math.round(compare * 100) - Math.round(state.price * 100)) * 100 / Math.round(compare * 100)) + '% off');
      setText('saleCaption', 'Marked down from ' + money(compare));
      setText('packWas', money(compare));
    }
    var pricebar = document.querySelector('.pricebar');
    if (pricebar) {
      pricebar.classList.toggle('onsale', sale);
      var perUnit = card.hasAttribute('data-per-unit') ? card.dataset.perUnit === 'true' : pricebar.dataset.perUnit === 'true';
      pricebar.dataset.perUnit = String(perUnit);
      var perLabel = pricebar.querySelector('.per'); if(perLabel)perLabel.textContent=perUnit?'per unit':'per pack';
      setHidden('perUnitLine', !perUnit);
      var calculator = document.querySelector('.calc'); if(calculator)calculator.hidden=!perUnit;
      setText('unitPrice', money(perUnit ? UNIT : state.price));
      setText('unitWas', money(perUnit ? compare / state.pcs : compare));
    }
    setText('calcUnitCost', money(UNIT));
    var multiplier = document.querySelector('.mults button.on');
    if (el('retail') && multiplier) {
      var mult = multiplier.getAttribute('data-m');
      el('retail').value = money(UNIT * (mult === 'custom' ? parseFloat(el('mCustom').value) || 2.5 : parseFloat(mult) || 2.5));
    }
    var save = document.querySelector('.pdpsave');
    if (save) {
      save.setAttribute('data-vid', card.getAttribute('data-vid'));
      save.setAttribute('data-price', state.price);
      save.setAttribute('data-unit', UNIT);
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', card.getAttribute('data-vid'));
    history.replaceState(history.state, '', url);
    document.dispatchEvent(new CustomEvent('wft:variant', { detail: { variantId: card.dataset.vid, sku: sku || '', price: state.price, quantity: Number(qty.value) || 1 } }));
    var mainImg = document.querySelector('.gal .main img');
    var colourSwatch = swatches.find(function (s) { return s.getAttribute('data-c') === card.getAttribute('data-c'); });
    var full = card.getAttribute('data-img') || (colourSwatch && colourSwatch.getAttribute('data-img')) || defaultImage;
    if (mainImg) mainImg.dispatchEvent(new Event('variant:image'));
    if (mainImg && full && mainImg.getAttribute('src') !== full) {
      mainImg.removeAttribute('srcset');
      mainImg.onload = function () {
        if (mainImg.naturalWidth) { mainImg.width = mainImg.naturalWidth; mainImg.height = mainImg.naturalHeight; }
      };
      mainImg.src = full;
    }
    document.querySelectorAll('.gal .thumbs img').forEach(function (t) {
      t.classList.toggle('on', t.getAttribute('data-full') === full);
    });

    // A pack chosen from the sold-out accordion cannot be bought: disable the
    // button rather than let the add fail at Shopify, and offer the alert.
    var soldOut = card.getAttribute('data-oos') === '1' || card.classList.contains('off');
    var addBtn = el('addBtn');
    if (addBtn) {
      addBtn.disabled = soldOut;
      var lab = addBtn.querySelector('span');
      if (lab) {
        if (soldOut) {
          if (!addBtn.getAttribute('data-label')) addBtn.setAttribute('data-label', lab.textContent);
          lab.hidden = true;
          addBtn.setAttribute('aria-label', 'Pack sold out');
        } else if (addBtn.getAttribute('data-label')) {
          lab.hidden = false;
          addBtn.removeAttribute('aria-label');
          addBtn.removeAttribute('data-label');
        }
      }
      var soldLabel = addBtn.querySelector('.pack-sold-label');
      if (!soldLabel) {
        soldLabel = document.createElement('span');
        soldLabel.className = 'pack-sold-label';
        soldLabel.textContent = 'Pack sold out';
        addBtn.appendChild(soldLabel);
      }
      soldLabel.hidden = !soldOut;
      var tot = el('addTotal'); if (tot) tot.hidden = soldOut;
    }
    // Shop Pay would fail on the same variant, so it goes with it
    var pay = document.querySelector('.payrow');
    if (pay) pay.hidden = soldOut;
    var nr = el('notifyRow');
    if (nr && !document.querySelector('.packcard:not(.off)')) { /* handled by render() */ }
    else if (nr) nr.hidden = !soldOut;

    render();
  }

  function selectColour(name, preferredId) {
    state.colour = name;
    swatches.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-c') === name); });
    var cn = el('colourName');
    if (cn) cn.textContent = name.charAt(0) + name.slice(1).toLowerCase();

    var shown = [];
    avail.forEach(function (c) {
      var dc = c.getAttribute('data-c');
      var hit = dc === name || dc === '__all__';
      c.hidden = !hit;
      if (hit) shown.push(c);
    });
    var hiddenCount = 0;
    oos.forEach(function (c) {
      var dc2 = c.getAttribute('data-c');
      var hit = dc2 === name || dc2 === '__all__';
      c.hidden = !hit;
      if (hit) hiddenCount++;
    });

    // sold-out disclosure only exists when this colour has sold-out packs
    var box = el('oosBox');
    if (box) box.hidden = hiddenCount === 0;
    setText('oosCount', plural(hiddenCount, 'sold-out pack'));   // +/- carries open state

    var none = shown.length === 0;
    setHidden('allGone', !none);
    setHidden('buyRow', none);
    setHidden('notifyRow', !none);
    el('totline') && (el('totline').hidden = none);
    // when nothing is buyable there is nothing to hide — open it
    if (none && hiddenCount && box) box.open = true;

    if (!none) {
      var preferred = shown.concat(oos.filter(function (c) { return !c.hidden; })).find(function (c) { return c.getAttribute('data-vid') === preferredId; });
      selectPack(preferred || shown[0]);
    } else {
      // nothing buyable: still show this colour's real pack price, not the last one
      var firstOos = oos.filter(function (c) { return !c.hidden; })[0];
      if (firstOos) {
selectPack(firstOos);
      }
    }
  }

  function render() {
    var n = Math.max(1, parseInt(qty.value, 10) || 1);
    var capped = state.max !== Infinity && n > state.max;
    if (capped) n = state.max;
    qty.value = n;
    if (state.max !== Infinity) qty.max = state.max; else qty.removeAttribute('max');

    // the button stops, and says why — a control that silently refuses reads
    // as broken, which is how "4 of 3 packs" got sold in the first place
    var plusBtn = el('plus');
    if (plusBtn) plusBtn.disabled = state.max !== Infinity && n >= state.max;
    var cap = el('qtyCap');
    if (cap) {
      var atCeiling = state.max !== Infinity && n >= state.max;
      cap.hidden = !atCeiling;
      if (atCeiling) {
        cap.textContent = state.max === 1
          ? 'One pack is all we have left in this size run.'
          : state.max + ' packs is all we have left in this size run.';
      }
    }
    setText('packPrice', money(state.price));
    setText('packDesc', 'per ' + state.pcs + '-piece pack');
    // The promotion is a percentage off the pack, so both promo figures have to
    // follow the pack picker rather than sit on the price the page loaded with.
    var promoPct = Number(document.body.dataset.promoPercent) || 0;
    if (promoPct > 0 && promoPct < 100) {
      var promoPrice = state.price * (100 - promoPct) / 100;
      setText('promoWas', money(state.price));
      setText('promoNow', money(promoPrice));
      setText('promoPackPrice', money(promoPrice));
    }
    setText('addQty', plural(n, 'pack'));
    setText('addTotal', money(state.price * n));
    setText('pieces', plural(n * state.pcs, 'piece'));
    setText('perUnitLine', money(UNIT) + ' per unit');
    // "11 of 0 packs" is what an untracked variant used to say, because the
    // Liquid defaults its stock to zero. With no count to quote, don't quote one.
    setText('ofPacks', state.stock > 0
      ? n + ' of ' + plural(state.stock, 'pack')
      : plural(n, 'pack'));
    calc();
    document.dispatchEvent(new CustomEvent('wft:quantity'));
  }

  function calc() {
    var r = el('retail');
    if (!r) return;
    var v = window.wftParseMoney(r.value);
    if (!isFinite(v) || v <= 0) v = UNIT * 2.5;
    var m = v - UNIT;
    setText('mUnit', money(m));
    setText('mPack', money(m * state.pcs));
    setText('mPct', Math.round((m / v) * 100) + '%');
  }

  swatches.forEach(function (s) {
    s.addEventListener('click', function () { selectColour(s.getAttribute('data-c')); });
  });
  avail.concat(oos).forEach(function (c) {
    c.addEventListener('click', function () { if (!c.hidden) selectPack(c); });
  });

  var minus = el('minus'), plus = el('plus');
  if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); render(); });
  if (plus)  plus.addEventListener('click', function () {
    var next = (parseInt(qty.value, 10) || 1) + 1;
    qty.value = state.max === Infinity ? next : Math.min(next, state.max);
    render();
  });
  qty.addEventListener('change', render);

  var retail = el('retail');
  if (retail) {
    retail.addEventListener('input', function () {
      document.querySelectorAll('.mults button').forEach(function (b) { b.classList.remove('on'); });
      calc();
    });
    retail.addEventListener('blur', function () {
      var v = window.wftParseMoney(retail.value);
      retail.value = money(isFinite(v) && v > 0 ? v : UNIT * 2.5);
      calc();
    });
    var customBtn = el('mCustomBtn'), customIn = el('mCustom');
    function applyMult(m) { retail.value = money(UNIT * m); calc(); }

    document.querySelectorAll('.mults button').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.mults button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var m = b.getAttribute('data-m');
        if (m === 'custom') {
          // swap the chip for a live multiplier field
          if (customIn) {
            customIn.hidden = false;
            b.hidden = true;
            customIn.focus();
            customIn.select();
            applyMult(parseFloat(customIn.value) || 2.5);
          }
          return;
        }
        if (customIn) { customIn.hidden = true; }
        if (customBtn) { customBtn.hidden = false; }
        applyMult(parseFloat(m));
      });
    });

    if (customIn) {
      customIn.addEventListener('input', function () {
        var m = parseFloat(customIn.value);
        if (isFinite(m) && m > 0) applyMult(m);
      });
      customIn.addEventListener('blur', function () {
        if (!(parseFloat(customIn.value) > 0)) {
          customIn.hidden = true;
          if (customBtn) customBtn.hidden = false;
        }
      });
    }
  }

  var start = document.querySelector('#colourRow label.on') || swatches[0];
  if (start) { selectColour(start.getAttribute('data-c'), el('variantId') && el('variantId').value); }
  else {        // no colour option: show every pack
    avail.forEach(function (c) { c.hidden = false; });
    oos.forEach(function (c) { c.hidden = false; });
    var box0 = el('oosBox'); if (box0) box0.hidden = oos.length === 0;
    if (el('oosCount')) setText('oosCount', plural(oos.length, 'sold-out pack'));
    var initial = avail.concat(oos).find(function (c) { return c.getAttribute('data-vid') === el('variantId').value; });
    if (initial || avail[0] || oos[0]) selectPack(initial || avail[0] || oos[0]);
  }
})();

  // ---- announcement bar: rotate one message at a time on small screens ----
  // Count-agnostic on purpose: the theme renders these from editor blocks, so
  // the number of messages is whatever the client configured.
  (function () {
    var wrap = document.querySelector('.promo .in');
    if (!wrap) return;
    var items = wrap.querySelectorAll('span');
    if (items.length < 2) return;                 // nothing to rotate
    var mq = window.matchMedia('(max-width:900px)');
    var rm = window.matchMedia('(prefers-reduced-motion:reduce)');
    var i = 0, timer = null;
    function clear() {
      if (timer) { clearInterval(timer); timer = null; }
      [].forEach.call(items, function (s) { s.classList.remove('on'); });
    }
    function start() {
      clear();
      wrap.classList.add('js');
      i = 0; items[0].classList.add('on');
      if (rm.matches) return;                     // hold on the first message
      timer = setInterval(function () {
        items[i].classList.remove('on');
        i = (i + 1) % items.length;
        items[i].classList.add('on');
      }, 4500);
    }
    function sync() {
      if (mq.matches) start();
      else { clear(); wrap.classList.remove('js'); }
    }
    (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
    (rm.addEventListener ? rm.addEventListener('change', sync) : rm.addListener(sync));
    sync();
  })();

  // ---- collection: show more, in place of pagination ----------------------
  // Fetches the next paginated page and appends its cards. The button is a real
  // <a href> pointing at that page, so with JS off (and for crawlers) it still
  // navigates; the paginated links also remain in a <noscript> block.
  (function () {
    var box = document.getElementById('loadMore');
    if (!box) return;
    var btn = document.getElementById('lmBtn');
    if (!btn) return;
    var shownEl = document.getElementById('lmShown'),
        bar = document.getElementById('lmBar'),
        grid = document.querySelector('.goods'),
        total = parseInt(box.getAttribute('data-total'), 10) || 0,
        busy = false;

    var buffer = null, fillFailed = false;
    var initialProducts = grid.querySelectorAll('.card:not(.promocard):not([data-resurfaced]),.search-content').length;
    var shownOffset = Math.max(0, (Number(shownEl && shownEl.textContent) || 0) - initialProducts);
    function missingTiles() {
      if (grid.dataset.restoringPages) return 0;
      if (window.wftResurface) window.wftResurface(grid);
      if (!grid.hasAttribute('data-fill-collection') || grid.classList.contains('bulk')) return 0;
      var columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      var count = 0;
      Array.from(grid.children).filter(function(c){return c.classList.contains('card') && c.getClientRects().length;}).forEach(function(c){
        var span=c.classList.contains('promo-wide')?Math.min(2,columns):1;
        count+=span;
      });
      return (columns - count % columns) % columns;
    }
    function fillRow() { if (!fillFailed && missingTiles()) load(true, true); }
    document.addEventListener('wft:collection-restored', fillRow);
    if (grid.hasAttribute('data-fill-collection')) {
      new ResizeObserver(fillRow).observe(grid);
      new MutationObserver(fillRow).observe(grid, {attributes:true,attributeFilter:['style','class']});
    }
    var auto = document.getElementById('lmAuto'), observer;
    if (auto && 'IntersectionObserver' in window) {
      auto.parentNode.hidden = false;
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && auto.checked) load(true);
      }, { rootMargin: '0px 0px 200px 0px' });
      auto.addEventListener('change', function () {
        observer.disconnect();
        if (auto.checked) observer.observe(box);
      });
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      load(false);
    });
    function load(automatic, fillOnly) {
      var next = btn.getAttribute('href');
      if (!next || busy || !btn.isConnected || grid.dataset.restoringPages) return;
      busy = true;
      var label = btn.textContent;
      btn.textContent = 'Loading…';
      var pending = buffer ? Promise.resolve(buffer) : fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        }).then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
      pending.then(function (doc) {
          // A history restoration may have loaded this page while the request was in flight.
          var present = new Set(Array.from(grid.querySelectorAll('.card[data-product-id]:not([data-resurfaced])')).map(function (c) { return c.dataset.productId; }));
          doc.querySelectorAll('.goods .card[data-product-id]').forEach(function (c) { if (present.has(c.dataset.productId)) c.remove(); });
          var added = Array.from(doc.querySelectorAll('.goods .card,.goods .search-content'));
          // Stock-only rendering can leave a native catalog page empty. Advance
          // its link without buffering an empty page or scanning the entire catalog.
          if (!added.length && grid.dataset.hideSoldOut === 'true') {
            var following = doc.getElementById('lmBtn');
            var followingUrl = following && following.getAttribute('href');
            buffer = null; busy = false; fillFailed = true;
            if (auto) auto.checked = false;
            if (observer) observer.disconnect();
            var status = box.querySelector('[data-stock-page-status]');
            if (!status) { status = document.createElement('p'); status.dataset.stockPageStatus = ''; status.setAttribute('role','status'); box.prepend(status); }
            if (followingUrl && followingUrl !== next) {
              btn.setAttribute('href',followingUrl); btn.textContent = 'Continue browsing';
              status.textContent = 'No available styles on that catalog page. Continue to the next page.';
            } else { btn.remove(); status.textContent = 'You have reached the end of this collection.'; }
            return;
          }
          var stockStatus = box.querySelector('[data-stock-page-status]');
          if (stockStatus) stockStatus.remove();
          var take = fillOnly ? missingTiles() : added.length;
          if (!take) { buffer = doc; busy = false; btn.textContent = label; return; }
          added = added.slice(0, take);
          if (!added.length && btn.getAttribute('href') !== next) { buffer = null; busy = false; requestAnimationFrame(fillRow); return; }
          if (!added.length) throw new Error('no cards');
          document.dispatchEvent(new CustomEvent('wft:page-loaded', {detail:{url:next}}));
          var first = null;
          [].forEach.call(added, function (c) {
            var node = document.importNode(c, true);
            if (!first) first = node;
            grid.appendChild(node);
            c.remove();
          });
          // hand the button the page after this one, from the fetched markup
          var nextBox = doc.getElementById('loadMore');
          var nextBtn = doc.getElementById('lmBtn');
          buffer = doc.querySelector('.goods .card,.goods .search-content') ? doc : null;
          var url = buffer ? next : (nextBtn ? nextBtn.getAttribute('href') : '');
          var n = shownOffset + grid.querySelectorAll('.card:not(.promocard):not([data-resurfaced]),.search-content').length;
          if (shownEl) shownEl.textContent = n;
          if (bar && total) bar.style.width = Math.min(100, n / total * 100) + '%';
          if (url) {
            btn.setAttribute('href', url);
            btn.textContent = 'Show ' + (buffer ? buffer.querySelectorAll('.goods .card,.goods .search-content').length : (box.dataset.step || 24)) + ' more';
          } else {
            btn.parentNode.removeChild(btn);
            if (observer) observer.disconnect();
            if (auto) auto.parentNode.hidden = true;
          }
          if (nextBox) box.setAttribute('data-next', url);
          // re-bind cards that were just added (save, quick add, swatches)
          if (typeof window.wftBindCards === 'function') window.wftBindCards(grid);
          if (typeof window.wftPaintView === 'function') window.wftPaintView();
          if (typeof window.wftResort === 'function') window.wftResort();
          if (first && !automatic) {
            var f = first.querySelector('a, button');
            if (f) f.focus({ preventScroll: true });
          }
          busy = false;
          requestAnimationFrame(fillRow);
          if (observer && auto.checked && url) {
            observer.disconnect();
            observer.observe(box);
          }
        })
        .catch(function () {
          // fall back to normal navigation rather than leaving a dead button
          btn.textContent = label;
          busy = false;
          if (automatic) {
            fillFailed = true;
            if (auto) auto.checked = false;
            if (observer) observer.disconnect();
          } else window.location.href = next;
        });
    }
  })();

  // ---- sort: compact trigger + popup, built over the native select --------
  // The <select> stays in the DOM and keeps doing the work (native orders still
  // submit the form, wholesale orders still fire 'change'), so this is purely a
  // presentation layer and the control still works with JS off.
  (function () {
    var sel = document.getElementById('sortSel');
    if (!sel) return;
    var wrap = sel.closest('.sortwrap');
    if (!wrap) return;
    wrap.classList.add('js-sort');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sortbtn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var menu = document.createElement('div');
    menu.className = 'sortmenu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    function label() { return sel.options[sel.selectedIndex].text; }
    function paint() {
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(label()));
      var c = document.createElement('i');
      c.setAttribute('aria-hidden', 'true');
      btn.appendChild(c);
      [].forEach.call(menu.querySelectorAll('[role="option"]'), function (o) {
        var on = o.getAttribute('data-v') === sel.value;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // mirror the select's structure, optgroups included
    [].forEach.call(sel.children, function (node) {
      if (node.tagName === 'OPTGROUP') {
        var h = document.createElement('span');
        h.className = 'sortgrp';
        h.textContent = node.label;
        menu.appendChild(h);
        [].forEach.call(node.children, addOpt);
      } else if (node.tagName === 'OPTION') {
        addOpt(node);
      }
    });
    function addOpt(o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'option');
      b.setAttribute('data-v', o.value);
      b.textContent = o.text;
      b.addEventListener('click', function () {
        sel.value = o.value;
        close();
        paint();
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.appendChild(b);
    }

    function open() {
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', away, true);
      document.addEventListener('keydown', esc, true);
      var cur = menu.querySelector('[aria-selected="true"]');
      if (cur) cur.focus();
    }
    function close() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', away, true);
      document.removeEventListener('keydown', esc, true);
    }
    function away(e) { if (!wrap.contains(e.target)) close(); }
    function esc(e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
      if (e.key === 'Tab' && !wrap.contains(document.activeElement)) close();
    }

    btn.addEventListener('click', function () { menu.hidden ? open() : close(); });
    wrap.appendChild(btn);
    wrap.appendChild(menu);
    paint();
    sel.addEventListener('change', paint);
  })();

  // ---- mega menu ---------------------------------------------------------
  // Hover and focus on a pointer; below 900px the links just navigate.
  (function initMega(root) {
    root=root||document;
    if(root===document)document.addEventListener('shopify:section:load',function(e){initMega(e.target);});
    var wraps = [].slice.call(root.querySelectorAll('[data-mega]:not([data-mega-ready])'));
    wraps.forEach(function(w){w.dataset.megaReady='true';});
    if (!wraps.length) return;
    var desktop = window.matchMedia('(min-width:901px)');
    var openWrap = null, closeTimer = null, suppress = false;

    function close(w) {
      if (!w) return;
      var panel = w.querySelector('.mega');
      var top = w.querySelector('.megatop');
      if (panel) panel.hidden = true;
      if (top) top.setAttribute('aria-expanded', 'false');
      if (openWrap === w) openWrap = null;
    }
    function open(w) {
      if (!desktop.matches || suppress) return;
      clearTimeout(closeTimer);
      if (openWrap && openWrap !== w) close(openWrap);
      var panel = w.querySelector('.mega');
      var top = w.querySelector('.megatop');
      if (panel) panel.hidden = false;
      if (top) top.setAttribute('aria-expanded', 'true');
      openWrap = w;
    }

    wraps.forEach(function (w) {
      w.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(w); });
      w.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { close(w); }, 140);
      });
      w.addEventListener('focusin', function () { clearTimeout(closeTimer); open(w); });
      w.addEventListener('focusout', function () {
        closeTimer = setTimeout(function () {
          if (!w.contains(document.activeElement)) close(w);
        }, 60);
      });
      // keyboard: the top link opens the panel rather than following straight through
      var top = w.querySelector('.megatop');
      if (top) top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(w);
          var first = w.querySelector('.mega a');
          if (first) first.focus();
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openWrap) {
        var t = openWrap.querySelector('.megatop');
        close(openWrap);
        // returning focus to the trigger fires focusin, which would reopen it
        suppress = true;
        if (t) t.focus();
        setTimeout(function () { suppress = false; }, 0);
      }
    });
    document.addEventListener('pointerdown',function(e){if(openWrap && !openWrap.contains(e.target))close(openWrap);});
    desktop.addEventListener
      ? desktop.addEventListener('change', function () { close(openWrap); })
      : desktop.addListener(function () { close(openWrap); });
  })();


  // ---- predictive search -------------------------------------------------
  // Shopify's own suggest endpoint, debounced, with the per-unit price pulled
  // from the product body the same way the rest of the theme derives it.
  (function () {
    var form = document.querySelector('.search');
    if (!form) return;
    var input = form.querySelector('input[type=search]');
    if (!input) return;

    var box = document.createElement('div');
    box.className = 'psbox';
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    box.setAttribute('aria-label', 'Search suggestions');
    form.appendChild(box);

    // routes.predictive_search_url is /search/suggest — the JSON API needs the
    // .json suffix, without which this fetched HTML and quietly failed.
    var base = (window.WFT && window.WFT.predictiveUrl) || '/search/suggest';
    if (!/\.json(\?|$)/.test(base)) base = base.replace(/\/?$/, '') + '.json';
    var searchUrl = (window.WFT && window.WFT.searchUrl) || '/search';
    var timer = null, lastQ = '', controller = null;

    function esc(t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : t;
      return d.innerHTML;
    }

    function hide() { box.hidden = true; box.innerHTML = ''; }

    function amount(v) {
      var n = parseFloat(v);
      if (!isFinite(n)) return '';
      return window.wftMoney(Math.round(n * 100));
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], collections = r.collections || [], pages = (r.pages || []).concat(r.articles || []);
      if (!products.length && !collections.length && !pages.length) {
        box.innerHTML = '<p class="psempty">No matches for &ldquo;' + esc(q) + '&rdquo;.</p>';
        box.hidden = false;
        return;
      }
      var html = '';
      if (products.length) {
        html += '<span class="psgrp">Styles</span>';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">'
            : '<img alt="">';
          // The suggest endpoint returns amounts in the shop's currency, not
          // in cents. money() divides by 100, so a $53.75 pack read as $0.54.
          // The cheapest pack is also not the only one, so a range says "from".
          var lo = amount(p.price_min != null ? p.price_min : p.price);
          var hi = amount(p.price_max != null ? p.price_max : p.price);
          var price = lo ? ((hi && hi !== lo) ? 'from ' + lo : lo) : '';
          html += '<a class="psitem" role="option" href="' + p.url + '">' + img +
                  '<span><b>' + esc(p.title) + '</b>' + (p.available === false ? '<span>Sold out</span>' : '') +
                  '<span>' + (window.WFT.hideVendors ? '' : esc(p.vendor || '')) + (price ? ((!window.WFT.hideVendors && p.vendor) ? ' &middot; ' : '') + price + ' per pack' : '') + '</span></span></a>';
        });
      }
      if (collections.length) {
        html += '<span class="psgrp">Categories</span>';
        collections.forEach(function (c) {
          html += '<a class="psitem" role="option" href="' + c.url + '"><span><b>' + esc(c.title) + '</b></span></a>';
        });
      }
      if (pages.length) {
        html += '<span class="psgrp">Pages</span>';
        pages.forEach(function (pg) {
          html += '<a class="psitem" role="option" href="' + pg.url + '"><span><b>' + esc(pg.title) + '</b></span></a>';
        });
      }
      html += '<a class="psmore" href="' + searchUrl + '?options%5Bunavailable_products%5D=last&q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      box.innerHTML = html;
      box.hidden = false;
    }

    function run(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = base + '?q=' + encodeURIComponent(q) +
                '&resources[type]=product,collection,page,article&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag&resources[limit]=6' +
                '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { if (data) render(data, q); })
        .catch(function () { /* aborted or offline — leave the last result up */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { run(q); }, 220);
    });
    input.addEventListener('focus', function () {
      if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false;
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); return; }
      if (e.key === 'ArrowDown' && !box.hidden) {
        var first = box.querySelector('.psitem');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', function (e) {
      var items = [].slice.call(box.querySelectorAll('.psitem'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1 && items[i + 1]) { e.preventDefault(); items[i + 1].focus(); }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (i > 0) items[i - 1].focus(); else input.focus();
      }
      if (e.key === 'Escape') { hide(); input.focus(); }
    });
  })();


  // ---- confetti ----------------------------------------------------------
  // Fired once when an order crosses the free-shipping line. Canvas rather than
  // a library: it is forty rectangles for a second, and the theme should not
  // carry a dependency for that. Silent under prefers-reduced-motion.
  window.wftConfetti = function (origin) {
    if (!origin || !origin.getBoundingClientRect) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = origin.getBoundingClientRect();
    if (!r.width) return;

    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:10000';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() { cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
    size();

    var COLORS = ['#CE2029', '#111111', '#DCCFBB', '#8A9A7B', '#FFFFFF'];
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    var bits = [];
    for (var i = 0; i < 46; i++) {
      var a = (-Math.PI / 2) + (Math.random() - 0.5) * 2.1;   // fan upward
      var sp = 5 + Math.random() * 9;
      bits.push({
        x: ox + (Math.random() - 0.5) * r.width * 0.7, y: oy,
        vx: Math.cos(a) * sp, vy: Math.sin(a) * sp,
        w: 4 + Math.random() * 5, h: 6 + Math.random() * 7,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.34,
        c: COLORS[(Math.random() * COLORS.length) | 0], life: 0
      });
    }

    var t0 = performance.now();
    function frame(now) {
      var dt = Math.min((now - t0) / 16.7, 3); t0 = now;
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      var alive = 0;
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        b.life += dt;
        b.vy += 0.34 * dt;          // gravity
        b.vx *= 0.995; b.vy *= 0.995;
        b.x += b.vx * dt; b.y += b.vy * dt; b.rot += b.vr * dt;
        var fade = Math.max(0, 1 - b.life / 105);
        if (b.y > innerHeight + 40 || fade <= 0) continue;
        alive++;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(b.x, b.y); ctx.rotate(b.rot);
        ctx.fillStyle = b.c;
        ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
        ctx.restore();
      }
      if (alive) requestAnimationFrame(frame);
      else if (cv.parentNode) cv.parentNode.removeChild(cv);
    }
    requestAnimationFrame(frame);
    setTimeout(function () { if (cv.parentNode) cv.parentNode.removeChild(cv); }, 4000);
  };

  // ---- cart drawer -------------------------------------------------------
  // Optional: settings.cart_drawer off leaves the cart link as a normal link.
  (function () {
    // Add ?wftdebug=1 to any storefront URL to see why the drawer is or is not
    // working. It reports to the console and paints a small panel on screen.
    var DEBUG = /[?&]wftdebug=1/.test(location.search);
    var report = [];
    function note(k, v) { report.push([k, v]); if (DEBUG) console.log('[WFT cart] ' + k + ':', v); }
    function paint() {
      if (!DEBUG) return;
      var box = document.createElement('div');
      box.setAttribute('style', 'position:fixed;left:10px;bottom:10px;z-index:99999;background:#111;' +
        'color:#fff;font:12px/1.5 ui-monospace,Menlo,monospace;padding:12px 14px;max-width:min(92vw,460px);' +
        'white-space:pre-wrap;border:1px solid #444');
      box.textContent = 'WFT cart drawer diagnostic\n' +
        report.map(function (r) { return '  ' + r[0] + ': ' + r[1]; }).join('\n');
      document.body.appendChild(box);
    }

    var drawer = document.getElementById('cartDrawer');
    note('script running', 'yes');
    note('drawer in DOM', !!drawer);
    if (!drawer) {
      note('verdict', 'cart-drawer snippet is not on the page — check layout/theme.liquid');
      if (document.readyState !== 'loading') paint();
      else document.addEventListener('DOMContentLoaded', paint);
      return;
    }
    // A missing #cartLines used to throw out of this block, and an uncaught
    // error aborts the whole script — everything defined after it, including
    // the cart page's own controls, silently stopped existing.
    if (!document.getElementById('cartLines')) {
      note('verdict', 'cart drawer markup is incomplete — #cartLines is missing');
      return;
    }
    var scrim = document.getElementById('cartScrim'),
        lines = document.getElementById('cartLines'),
        totalEl = document.getElementById('cartTotal'),
        closeBtn = document.getElementById('cartClose'),
        enabled = !(window.WFT && window.WFT.cartDrawer === false),
        cartUrl = (window.WFT && window.WFT.cartUrl) || '/cart';

    function money(c) {
      var n = typeof c === 'number' && isFinite(c) ? c : 0;
      return window.wftMoney(n);
    }
    function esc(t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : t;
      return d.innerHTML;
    }

    // The cart page shows what a promotion took off; the drawer has to say the
    // same thing or the buyer reads the discounted total as the full price.
    // A markdown lives on the variant and arrives as original vs final line
    // price; a discount code or automatic discount arrives as an allocation.
    function priceOf(i) {
      var fin = i.final_line_price != null ? i.final_line_price : i.line_price,
          orig = i.original_line_price != null ? i.original_line_price : fin;
      return orig > fin
        ? '<s>' + money(orig) + '</s><em>' + money(fin) + '</em>'
        : money(fin);
    }
    function discountsOf(i) {
      // Shopify names the discount on the allocation in older carts and on the
      // line's own `discounts` in newer ones; both shapes are in the wild.
      return (i.line_level_discount_allocations || i.discounts || []).map(function (d) {
        var title = (d.discount_application && d.discount_application.title) || d.title;
        if (!title) return '';
        return '<span class="cdisc">' + esc(title) + ' \u2212' + money(d.amount) + '</span>';
      }).join('');
    }
    function renderCartDiscounts(cart) {
      var box = document.getElementById('cartDiscounts');
      if (!box) return;
      box.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
        return '<p class="cdisc cdisc--cart">' + esc(d.title) + ' \u2212' + money(d.total_allocated_amount) + '</p>';
      }).join('');
    }

    function open(on) {
      drawer.classList.toggle('open', on);
      drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (scrim) scrim.classList.toggle('open', on);
      if (on) closeBtn && closeBtn.focus();
    }

    function render(cart, bundledHtml) {
      // /cart/change.js answers with an error object ({status, message,
      // description}) when it rejects a line. Rendering that produced the
      // "(undefined)" heading and the $NaN totals.
      if (!cart || !Array.isArray(cart.items)) {
        note('unexpected cart response', (cart && (cart.description || cart.message)) || 'not a cart');
        return load(false);          // fall back to the real cart
      }
      // a line at quantity 0 is on its way out; never draw it
      cart = Object.assign({}, cart, {
        items: cart.items.filter(function (i) { return i && i.quantity > 0; })
      });
      current = cart;
      document.dispatchEvent(new CustomEvent('wft:cart', {detail:cart}));
      if (!cart.items.length) {
        lines.innerHTML = '<p class="cdempty">Nothing in the order yet.</p>';
      } else {
        lines.innerHTML = cart.items.map(function (i, idx) {
          var img = i.image
            ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="60" height="80">'
            : '';
          // the whole line is a link to the product, which is what a buyer expects
          var line = idx + 1;                     // 1-based, as /cart/change.js wants
          var lim = limitOf(i);
          return '<div class="cdline" data-line="' + line + '">' +
            '<a class="cdimg" href="' + i.url + '">' + img + '</a>' +
            '<div class="cdinfo">' +
              '<a class="cdname" href="' + i.url + '">' +
                (window.WFT.hideVendors ? '' : '<span class="brand">' + esc(i.vendor || '') + '</span>') +
                '<span class="name">' + esc(i.product_title) + '</span>' +
              '</a>' +
              '<span class="cdrun">' + esc(i.variant_title || '') + '</span>' +
              discountsOf(i) +
              '<div class="cdactions"><div class="cdqty">' +
                '<button type="button" data-line="' + line + '" data-q="' + (i.quantity - 1) + '" aria-label="Remove one pack">&minus;</button>' +
                '<span>' + i.quantity + '</span>' +
                '<button type="button" data-line="' + line + '" data-q="' + (i.quantity + 1) + '"' +
                  (lim && i.quantity >= lim.max ? ' disabled' : '') +
                  ' aria-label="Add one pack">+</button>' +
              '</div>' +
              '<button type="button" class="cdrm" data-line="' + line + '" data-remove="1">Remove</button></div>' +
              (lim && i.quantity >= lim.max
                ? '<p class="cdlim" role="status">' + esc(lim.why) + '</p>' : '') +
            '</div>' +
            '<div class="cdprice"><span class="cdsale" data-cart-sale-key="' + esc(i.key) + '"></span>' +
              priceOf(i) + '</div>' +
            '</div>';
        }).join('');
      }
      if (cart.items.length) loadSaleBadges(cart, bundledHtml);
      renderCartDiscounts(cart);
      if (totalEl) totalEl.textContent = money(cart.total_price);

      // free shipping progress, redrawn on every change — every bar on the page
      window.wftShipBar(cart.total_price, document.getElementById('cartCheckout'));
      [].forEach.call(document.querySelectorAll('.cartcount, .cdcount'), function (e) {
        var n = typeof cart.item_count === 'number' ? cart.item_count
              : cart.items.reduce(function (a, i) { return a + (i.quantity || 0); }, 0);
        e.textContent = e.classList.contains('cdcount') ? '(' + n + ')' : n;
      });
    }

    function loadSaleBadges(cart, bundledHtml) {
      (bundledHtml ? Promise.resolve(bundledHtml) : fetch(cartUrl + '?section_id=cart-sale-badges', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('Sale badges unavailable'); return r.text(); }))
        .then(function (html) {
          // A slow response must never add badges to a newer cart render.
          if (current !== cart) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var badges = new Map();
          doc.querySelectorAll('[data-cart-sale-key]').forEach(function (row) {
            var badge = row.querySelector('.cart-sale-badge');
            if (badge) badges.set(row.getAttribute('data-cart-sale-key'), badge.textContent);
          });
          lines.querySelectorAll('[data-cart-sale-key]').forEach(function (slot) {
            var label = badges.get(slot.getAttribute('data-cart-sale-key'));
            if (!label) return;
            var badge = document.createElement('span');
            badge.className = 'flag cart-sale-badge';
            badge.textContent = label;
            slot.replaceChildren(badge);
          });
        })
        .catch(function () { /* Badge failures must not interrupt cart controls. */ });
    }

    // A failed section render never retries the mutation: read the cart instead.
    function showAdded(response) {
      var html = response && response.sections && response.sections['cart-sale-badges'];
      if (html) {
        try {
          var state = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-state]');
          var cart = state && JSON.parse(state.textContent);
          if (cart && Array.isArray(cart.items)) { render(cart, html); open(true); return Promise.resolve(); }
        } catch (error) { /* Shopify may return a null or incomplete section. */ }
      }
      return load(true);
    }
    window.wftShowAddedCart = showAdded;

    function load(thenOpen) {
      var before = current;
      return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (current === before) render(c); if (thenOpen) open(true); })
        .catch(function (err) {
          note('cart fetch failed', (err && err.message) || err);
          if (DEBUG) { paint(); return; }        // stay put so the panel is readable
          if (thenOpen) window.location.href = cartUrl;
        });
    }

    // `line` is the 1-based position in the cart as it stands right now, which
    // is always valid for the payload we just drew from. A line key can be
    // rejected after Shopify merges or re-keys a line, and the 422 that comes
    // back is what was being rendered as a phantom $0.00 row.
    // Shopify answers an over-add with a 422 and a sentence explaining it.
    // That sentence used to go to a debug panel no buyer ever sees, so the
    // number simply snapped back and the button looked broken. Keyed by
    // variant id, because removing a line renumbers every line under it.
    var limits = {};
    var current = null;              // the last cart drawn, for addressing lines
    function limitOf(item) { return item && limits[item.id]; }
    function plain(html) {
      var d = document.createElement('div');
      d.innerHTML = html == null ? '' : String(html);
      return (d.textContent || '').trim();
    }

    function change(line, qty) {
      return fetch(wftRoute('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || !Array.isArray(res.body.items)) {
            var why = plain(res.body && (res.body.description || res.body.message));
            note('change rejected', why);
            // pin the reason to the line it belongs to, then re-read the cart
            // so the quantity shown is the one Shopify actually holds
            var item = current && current.items && current.items[line - 1];
            if (item) limits[item.id] = { max: item.quantity, why: why || 'No more of this pack is available.' };
            return load(false);
          }
          // a line that took a change is no longer at its ceiling
          var moved = res.body.items[line - 1];
          if (moved) delete limits[moved.id];
          render(res.body);
        })
        .catch(function () { return load(false); });
    }

    // quantity buttons inside the drawer
    var busy = false;
    // Putting a line back means adding it again, since /cart/change.js cannot
    // resurrect one. It returns to the bottom of the cart rather than its old
    // position, which is the one thing an undo here cannot preserve.
    function undoAdd(item) {
      return fetch(wftRoute('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: item.id, quantity: item.quantity, properties: item.properties || undefined
        })
      }).then(function () { return load(false); }, function () { return load(false); });
    }

    lines.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-line]') : null;
      if (!b) return;
      e.preventDefault();
      if (busy) return;                       // a double tap would send two changes
      var line = parseInt(b.getAttribute('data-line'), 10);
      if (!isFinite(line)) return;

      if (b.getAttribute('data-remove') === '1') {
        var gone = current && current.items && current.items[line - 1];
        if (!gone) return;
        var keep = { id: gone.id, quantity: gone.quantity, properties: gone.properties };
        var what = gone.quantity === 1 ? '1 pack removed' : gone.quantity + ' packs removed';
        busy = true;
        change(line, 0).then(function () {
          busy = false;   // an exception below must not be mistaken for a failed change
          delete limits[keep.id];
          // toast() belongs to the saved-drawer block; this is a different IIFE
          if (window.wftToast) window.wftToast(what, 'Undo', function () { undoAdd(keep); }, 6000);
        }, function () { busy = false; });
        return;
      }

      var qty = parseInt(b.getAttribute('data-q'), 10);
      if (!isFinite(qty) || qty < 0) return;
      busy = true;
      change(line, qty).then(function () { busy = false; }, function () { busy = false; });
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { open(false); });
    if (scrim) scrim.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) open(false);
    });

    note('setting cart_drawer', (window.WFT && window.WFT.cartDrawer));
    note('cartUrl', cartUrl);
    note('cart links found', document.querySelectorAll('a[href*="/cart"]').length);
    if (document.readyState !== 'loading') paint();
    else document.addEventListener('DOMContentLoaded', paint);

    if (!enabled) return;   // leave every cart link as a plain navigation
    document.addEventListener('wft:open-cart', function () { load(true); });

    // Delegated, not bound to the links themselves: the theme editor re-renders
    // a section whenever a setting changes, which throws away listeners
    // attached at load. This also covers cart links added by later markup.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.classList.contains('cdview') || a.id === 'cartCheckout') return;
      var href = a.getAttribute('href') || '';
      if (!/\/cart(\?|#|$)/.test(href)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;   // let new-tab through
      e.preventDefault();
      e.stopPropagation();
      note('cart link clicked', href);
      load(true);
    }, true);   // capture: the theme editor intercepts anchor clicks on the way
                // up, so a bubble-phase listener never sees them and the drawer
                // only worked on the storefront preview

    // A submitted form has exactly one request and one confirmed outcome.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = new URL(form.action, location.href);
      if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
      e.preventDefault();
      if (form.dataset.addBusy === '1') return;
      var variant = form.querySelector('[name="id"]'), qty = form.querySelector('[name="quantity"]');
      if (!variant || !variant.value || (qty && !qty.checkValidity())) { if (qty) qty.reportValidity(); return; }
      form.dataset.addBusy = '1';
      var btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = true;
      var error = form.querySelector('.add-error');
      if (!error) { error = document.createElement('p'); error.className = 'add-error'; error.setAttribute('role', 'alert'); form.appendChild(error); }
      error.textContent = '';
      var requested = Number(qty && qty.value) || 1;
      var payload = new FormData(form);
      payload.set('sections','cart-sale-badges'); payload.set('sections_url',cartUrl);
      var buttonLabel = btn && !btn.children.length ? btn.textContent : null;
      if (btn) { if (buttonLabel !== null) btn.textContent = 'Adding…'; btn.setAttribute('aria-busy','true'); }
      fetch(wftRoute('cart/add.js'), { method: 'POST', body: payload, headers: {Accept:'application/json'} })
        .then(function (r) { return r.json().then(function (res) { if (!r.ok || res.status) throw new Error(res.description || 'Could not add this pack'); return res; }); })
        .then(function (res) {
          window.wftTrack('quick_add_success', {variant_id:String(res.variant_id || res.id), add_source:form.id === 'AddForm' ? 'product_page' : (form.closest('[data-resurfaced]') ? 'resurfaced_variant' : (form.closest('.goods.bulk') ? 'bulk' : 'quick_add')), quantity:requested, value:(res.final_price || res.price || 0) * requested / 100});
          document.dispatchEvent(new Event('wft:close-quick-add'));
          return showAdded(res);
        })
        .catch(function (err) {
          error.textContent = err.message || 'Could not add that pack. Please try again.';
          window.wftTrack('quick_add_error', {variant_id:variant.value});
        })
        .finally(function () { form.dataset.addBusy = '0'; if (btn) { if (buttonLabel !== null) btn.textContent = buttonLabel; btn.removeAttribute('aria-busy'); btn.disabled = !variant.value; } });
    }, true);

    // The editor re-renders sections as settings change; keep the header count
    // and drawer contents in step with whatever it just rebuilt.
    document.addEventListener('shopify:section:load', function () { load(false); });

    load(false);   // sync the header count on load
  })();


  // ---- collection view: density in a menu, the rest as icons -------------
  (function () {
    var group = document.getElementById('perRow');
    if (!group) return;
    var ctl = group.closest('.viewctl');
    var label = ctl && ctl.querySelector('.vlabel');
    if (!ctl) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'viewbtn';
    btn.setAttribute('aria-haspopup', 'true');
    btn.setAttribute('aria-expanded', 'false');

    var menu = document.createElement('div');
    menu.className = 'viewmenu';
    menu.hidden = true;

    var head = document.createElement('span');
    head.className = 'sortgrp';
    head.textContent = 'Styles per row';
    menu.appendChild(head);
    menu.appendChild(group);       // move the real control into the menu
    group.hidden = false;

    function current() {
      var on = group.querySelector('button.on');
      return on ? on.getAttribute('data-n') : '5';
    }
    function paint() {
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode('View · ' + current()));
      var c = document.createElement('i');
      c.setAttribute('aria-hidden', 'true');
      btn.appendChild(c);
    }
    function close() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', away, true);
    }
    function away(e) { if (!ctl.contains(e.target)) close(); }
    btn.addEventListener('click', function () {
      if (menu.hidden) {
        menu.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', away, true);
      } else { close(); }
    });
    group.addEventListener('click', function (e) {
      if (e.target.closest('button[data-n]')) { paint(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { close(); btn.focus(); }
    });

    if (label) label.hidden = true;
    ctl.insertBefore(btn, ctl.firstChild);
    ctl.insertBefore(menu, btn.nextSibling);
    paint();
  })();

  // ---- compact by default on a phone -------------------------------------
  // The collection grid gets this from the view controls' saved state. Strips
  // on the homepage have no controls, so they would otherwise stay roomy.
  (function () {
    if (!window.matchMedia('(max-width:900px)').matches) return;
    [].forEach.call(document.querySelectorAll('.goods'), function (g) {
      var scope = g.closest('.in');
      var controlled = scope && scope.querySelector('#perRow');
      if (!controlled) g.classList.add('compact');
    });
  })();

  // ---- cart page: quantity steppers and remove -----------------------------
  // The markup shipped with these controls but no behaviour, so only the native
  // "Update" button did anything. Lines are addressed by position, same as the
  // drawer, because a line key can stop matching after Shopify re-keys a line.
  (function () {
    var form = document.querySelector('.cartform');
    if (!form) return;

    function rows() { return [].slice.call(form.querySelectorAll('.cline')); }
    function money(c) {
      var n = typeof c === 'number' && isFinite(c) ? c : 0;
      return window.wftMoney(n);
    }

    var busy = false;

    function change(line, qty) {
      if (busy) return;
      busy = true;
      form.setAttribute('aria-busy', 'true');
      fetch(wftRoute('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || !Array.isArray(res.body.items)) {
            // the cart page swallowed this the same way the drawer did: it
            // posted the form and the number came back changed with no reason
            var d = document.createElement('div');
            d.innerHTML = (res.body && (res.body.description || res.body.message)) || '';
            var why = (d.textContent || '').trim() || 'No more of this pack is available.';
            var row = rows()[line - 1];
            if (row) {
              var note = row.querySelector('.cdlim');
              if (!note) {
                note = document.createElement('p');
                note.className = 'cdlim';
                note.setAttribute('role', 'status');
                (row.querySelector('.cqty') || row).appendChild(note);
              }
              note.textContent = why;
            }
            busy = false;
            form.removeAttribute('aria-busy');
            return fetch(wftRoute('cart.js'), { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) { if (c && Array.isArray(c.items)) apply(c); });
          }
          // A removal renumbers every line below it, and an emptied cart swaps
          // in a different template — let the server redraw those.
          if (res.body.items.length !== rows().length || !res.body.items.length) {
            window.location.reload();
            return;
          }
          apply(res.body);
          busy = false;
          form.removeAttribute('aria-busy');
        })
        .catch(function () {
          // fall back to the native form post rather than leave it looking dead
          busy = false;
          form.removeAttribute('aria-busy');
          form.submit();
        });
    }

    function apply(cart) {
      document.dispatchEvent(new CustomEvent('wft:cart', {detail:cart}));
      rows().forEach(function (row, i) {
        var item = cart.items[i];
        if (!item) return;
        var stale = row.querySelector('.cdlim');
        if (stale && item.quantity < (parseInt(stale.getAttribute('data-at'), 10) || Infinity)) {
          stale.parentNode.removeChild(stale);
        }
        var input = row.querySelector('.cqty input');
        if (input) input.value = item.quantity;
        var price = row.querySelector('.cprice-value');
        // final_line_price is what the buyer pays once discounts apply
        var paid = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
        if (price) {
          if (typeof item.original_line_price === 'number' && item.original_line_price > paid) {
            price.innerHTML = '<s>' + money(item.original_line_price) + '</s> <em>' + money(paid) + '</em>';
          } else {
            price.textContent = money(paid);
          }
        }
      });
      var version = String(Date.now()); form.dataset.badgeVersion = version;
      fetch((window.WFT.cartUrl || '/cart') + '?section_id=cart-sale-badges')
        .then(function (r) { if (!r.ok) throw new Error('Badges unavailable'); return r.text(); })
        .then(function (html) {
          if (form.dataset.badgeVersion !== version) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          rows().forEach(function (row, i) {
            var slot = row.querySelector('.cprice-sale'); if (!slot) return;
            var source = Array.from(doc.querySelectorAll('[data-cart-sale-key]')).find(function (node) { return node.dataset.cartSaleKey === cart.items[i].key; });
            if (source) slot.innerHTML = source.innerHTML;
          });
        }).catch(function () {});
      var status = document.getElementById('cartStatus');
      if (status) {
        status.textContent = 'Order updated. ' +
          (cart.item_count === 1 ? '1 pack' : cart.item_count + ' packs') +
          ', subtotal ' + money(cart.total_price) + '.';
      }
      var total = document.querySelector('.ctotal');
      if (total) total.textContent = money(cart.total_price);

      [].forEach.call(document.querySelectorAll('.cartcount, .cdcount'), function (e) {
        var n = typeof cart.item_count === 'number' ? cart.item_count : 0;
        e.textContent = e.classList.contains('cdcount') ? '(' + n + ')' : n;
      });

      window.wftShipBar(cart.total_price, form.querySelector('[name=checkout]'));
    }

    function lineOf(el) {
      var row = el.closest('.cline');
      return rows().indexOf(row) + 1;      // 1-based
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.cplus, .cminus, .cremove') : null;
      if (!btn) return;
      e.preventDefault();
      var row = btn.closest('.cline');
      var input = row && row.querySelector('.cqty input');
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      var next = btn.classList.contains('cremove') ? 0
               : btn.classList.contains('cplus') ? current + 1
               : current - 1;
      if (next < 0) next = 0;
      change(lineOf(btn), next);
    });

    // typing a quantity should commit too, not wait for the Update button
    form.addEventListener('change', function (e) {
      var input = e.target.closest ? e.target.closest('.cqty input') : null;
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (!isFinite(n) || n < 0) { n = 0; input.value = 0; }
      change(lineOf(input), n);
    });
  })();

  // ---- product recommendations ---------------------------------------------
  // Shopify's Product Recommendations API needs its own request: the list is
  // computed per product and cached separately from the page. The section
  // renders empty, we fetch the same section by id, and swap its contents in.
  (function () {
    var host = document.querySelector('[data-recs]');
    if (!host) return;
    var url = host.getAttribute('data-url');
    if (!url) return;
    function loadRecommendations() {
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (!fresh || !fresh.innerHTML.trim()) return;   // nothing recommended
        host.innerHTML = fresh.innerHTML;
        // the cards arrived after page load, so give them their handlers
        if (typeof window.wftBindCards === 'function') window.wftBindCards(host);
        if (typeof window.wftInitRecommendations === 'function') window.wftInitRecommendations(host);
      })
      .catch(function () { /* leave the section empty rather than half-drawn */ });
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();loadRecommendations();
      }, {rootMargin:'800px'});
      observer.observe(host);
    } else loadRecommendations();
  })();

  // ---- filters: show every value in a group --------------------------------
  // "Show all 16" used to be inert text and only the first six values were
  // rendered at all. Every value is now in the markup; the extras start hidden.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.morebtn') : null;
    if (!btn) return;
    e.preventDefault();
    var list = btn.closest('ul');
    if (!list) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    [].forEach.call(list.querySelectorAll('.xtra'), function (li) { li.hidden = open; });
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    btn.textContent = open ? 'Show all ' + btn.getAttribute('data-n') : 'Show fewer';
  });

  // ---- click the SKU to copy it --------------------------------------------
  // Buyers quote a SKU back over WhatsApp and email constantly; selecting six
  // characters of 10px grey text by hand is the kind of thing that loses a sale.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.skucopy') : null;
    if (!btn) return;
    var field = btn.querySelector('span');   // the icons live in a sibling span
    var text = ((field ? field.textContent : btn.textContent) || '').trim();
    if (!text) return;

    function done() {
      btn.setAttribute('data-copied', '1');
      window.clearTimeout(btn._copyT);
      btn._copyT = window.setTimeout(function () { btn.removeAttribute('data-copied'); }, 1600);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else {
      fallback();
    }

    // clipboard API needs a secure context; a theme preview is not always one
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) { /* nothing to do */ }
      document.body.removeChild(ta);
    }
  });

// Mobile navigation is an inline disclosure; links remain in normal tab order.
(function () {
  function initHeader() {
    document.querySelectorAll('.mobile-menu-toggle').forEach(function (toggle) {
      if (toggle.dataset.ready) return;
      toggle.dataset.ready = 'true';
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      function setOpen(open, returnFocus) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close full menu' : 'Open full menu');
        if (returnFocus) toggle.focus();
      }
      toggle.addEventListener('click', function () { setOpen(panel.hidden); });
      document.addEventListener('pointerdown',function(e){if(!panel.hidden && !panel.closest('nav').contains(e.target))setOpen(false);});
      panel.closest('nav').querySelectorAll('[data-mobile-submenu]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (!window.matchMedia('(max-width:900px)').matches) return;
          var submenu = document.getElementById(link.dataset.mobileSubmenu);
          if (!submenu) return;
          event.preventDefault();
          setOpen(true);
          panel.querySelectorAll('details').forEach(function (item) { item.open = false; });
          submenu.open = true;
          submenu.querySelector('summary').focus({ preventScroll: true });
          panel.scrollTop = submenu.offsetTop - panel.offsetTop;
        });
      });
      panel.querySelector('[data-menu-close]').addEventListener('click', function () { setOpen(false, true); });
      panel.closest('nav').addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { setOpen(false, true); }
      });
      window.matchMedia('(min-width:901px)').addEventListener('change', function (e) {
        if (e.matches) setOpen(false);
      });
    });
    document.querySelectorAll('[data-benefits]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      var group = bar.querySelector('.benefits-group');
      if (!group || !group.children.length) return;
      var copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('*').forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
        el.removeAttribute('id');
      });
      group.parentNode.appendChild(copy);
      bar.classList.add('is-looping');
      function size() { bar.style.setProperty('--benefits-duration', Math.max(16, group.getBoundingClientRect().width / 30) + 's'); }
      var observer = new ResizeObserver(size);
      observer.observe(group);
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target.contains(bar)) observer.disconnect();
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader);
  else initHeader();
  document.addEventListener('shopify:section:load', initHeader);
})();

// Product strips round their requested tile count up to the actual responsive columns.
(function () {
  function init(root) {
    root.querySelectorAll('[data-complete-rows]:not([data-rows-ready])').forEach(function (grid) {
      grid.dataset.rowsReady = 'true';
      var cards = [];
      Array.from(grid.children).forEach(function (child) {
        if (child.matches('template[data-row-reserve]')) {
          cards.push(child.content.firstElementChild); child.remove();
        } else if (child.classList.contains('card')) cards.push(child);
      });
      cards = cards.filter(Boolean);
      var target = Number(grid.dataset.rowTarget) || 15;
      var last = '';
      function update() {
        var columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
        var mobile = matchMedia('(max-width:900px)').matches;
        var eligible = cards.filter(function(card){return !card.classList.contains(mobile?'promo-no-mobile':'promo-no-desktop');});
        var key=columns+':'+mobile;
        if(key===last)return;last=key;
        var budget=Math.ceil(target/columns)*columns,used=0,visible=[];
        // Reserve configured promotions, then fill the remaining spaces with products.
        var promos=eligible.filter(function(c){return c.classList.contains('promocard');});
        var reserved=promos.reduce(function(n,c){return n+(c.classList.contains('promo-wide')?Math.min(2,columns):1);},0);
        var products=Math.max(0,budget-reserved);
        eligible.forEach(function(card){
          if(card.classList.contains('promocard'))visible.push(card);
          else if(products-->0)visible.push(card);
        });
        visible.forEach(function(card){used+=card.classList.contains('promo-wide')?Math.min(2,columns):1;});
        var needed=(columns-used%columns)%columns;
        eligible.filter(function(c){return !c.classList.contains('promocard') && visible.indexOf(c)<0;}).slice(0,needed).forEach(function(c){visible.push(c);});
        cards.forEach(function(card){if(visible.indexOf(card)<0)card.remove();});
        visible.forEach(function(card){grid.appendChild(card);});
        if (window.wftBindCards) window.wftBindCards(grid);
      }
      var observer = new ResizeObserver(update); observer.observe(grid);
      update();
      document.addEventListener('shopify:section:unload', function (event) { if (event.target.contains(grid)) observer.disconnect(); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
